import type { Locale } from '@packages/config';
import { getCmsDataCacheKey } from './getCmsDataCacheKey';

export const getUspCacheKey = (device: 'web' | 'mob', locale: Locale): string =>
  getCmsDataCacheKey('usp', device, locale);
